"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAccents = exports.hasAtLeastNDigitCharacters = exports.escapeHtml = exports.decodeHTMLEntities = exports.stringify = exports.lowercaseFirst = exports.capitalize = exports.truncateString = exports.getFormattedMessageWithLineBreaks = exports.camelCaseToPascalCase = exports.pascalCaseToCamelCase = exports.camelCaseToSnakeCase = exports.snakeCaseToCamelCase = exports.kebabCaseToCamelCase = void 0;
exports.decodeHtmlEntities = decodeHtmlEntities;
const kebabCaseToCamelCase = (value) => {
    return value.replace(/([-][a-z])/gi, (group) => group.toUpperCase().replace("-", ""));
};
exports.kebabCaseToCamelCase = kebabCaseToCamelCase;
const snakeCaseToCamelCase = (value) => {
    return value.replace(/([_][a-z])/gi, (group) => group.toUpperCase().replace("_", ""));
};
exports.snakeCaseToCamelCase = snakeCaseToCamelCase;
const camelCaseToSnakeCase = (value) => {
    return value.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? "_" : "") + match.toLowerCase());
};
exports.camelCaseToSnakeCase = camelCaseToSnakeCase;
const pascalCaseToCamelCase = (value) => {
    return `${value[0].toLowerCase()}${value.substr(1, value.length)}`;
};
exports.pascalCaseToCamelCase = pascalCaseToCamelCase;
const camelCaseToPascalCase = (value) => {
    return `${value[0].toUpperCase()}${value.substr(1, value.length)}`;
};
exports.camelCaseToPascalCase = camelCaseToPascalCase;
const getFormattedMessageWithLineBreaks = (value) => {
    return value.replace(/\n/g, "<br />");
};
exports.getFormattedMessageWithLineBreaks = getFormattedMessageWithLineBreaks;
const truncateString = (value, end) => {
    return value?.length > end ? `${value.substring(0, end)}...` : value;
};
exports.truncateString = truncateString;
const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
exports.capitalize = capitalize;
const lowercaseFirst = (text) => (text ? text.charAt(0).toLowerCase() + text.slice(1) : text);
exports.lowercaseFirst = lowercaseFirst;
// Remove circular dependencies from an object before stringifying it.
const stringify = (obj) => {
    const cache = [];
    const str = JSON.stringify(obj, (_key, value) => {
        if (typeof value === "object" && value !== null) {
            if (cache.includes(value)) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
        return value;
    });
    // Reset the cache
    cache.length = 0;
    return str;
};
exports.stringify = stringify;
const decodeHTMLEntities = (input) => input.replace(/&amp;/g, "&");
exports.decodeHTMLEntities = decodeHTMLEntities;
const NAMED_HTML_ENTITIES = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
    ndash: "–",
    mdash: "—",
    hellip: "…",
    lsquo: "\u2018",
    rsquo: "\u2019",
    ldquo: "\u201C",
    rdquo: "\u201D",
    laquo: "«",
    raquo: "»",
    eacute: "é",
    egrave: "è",
    ecirc: "ê",
    agrave: "à",
    acirc: "â",
    ccedil: "ç",
    ocirc: "ô",
    ucirc: "û",
    ugrave: "ù",
    icirc: "î",
    copy: "©",
    reg: "®",
    trade: "™",
};
function decodeNumericEntity(codePoint, fallback) {
    const isValidCodePoint = Number.isInteger(codePoint) &&
        codePoint >= 0 &&
        codePoint <= 0x10ffff &&
        !(codePoint >= 0xd800 && codePoint <= 0xdfff);
    return isValidCodePoint ? String.fromCodePoint(codePoint) : fallback;
}
function decodeHtmlEntities(text) {
    return text.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (match, entity) => {
        if (entity.startsWith("#x") || entity.startsWith("#X")) {
            return decodeNumericEntity(Number.parseInt(entity.slice(2), 16), match);
        }
        if (entity.startsWith("#")) {
            return decodeNumericEntity(Number.parseInt(entity.slice(1), 10), match);
        }
        return NAMED_HTML_ENTITIES[entity.toLowerCase()] ?? match;
    });
}
const escapeHtml = (value) => value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
exports.escapeHtml = escapeHtml;
const hasAtLeastNDigitCharacters = (value, n) => Boolean(value.match(new RegExp(`(\\D*\\d){${n},}`, "g"))?.length);
exports.hasAtLeastNDigitCharacters = hasAtLeastNDigitCharacters;
/**
 * Normalizes a string by removing accents/diacritics for comparison purposes.
 * Converts "Québec" to "Quebec", "Montréal" to "Montreal", etc.
 */
const normalizeAccents = (str) => {
    if (!str) {
        return "";
    }
    return str
        .normalize("NFD") // Decompose characters into base + combining characters
        .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
        .toLowerCase()
        .trim();
};
exports.normalizeAccents = normalizeAccents;
